<template>
    <div class="labelEdit" v-bind:class="{ active: label.isActive,'product-slide passed':(this.$store.getters.labels.length >1 || this.$store.getters.stocks.length) }">
        <a href="javascript:void(0)" class="opener" @click="setActive" v-if="((this.$store.getters.labels.length >1) ||this.$store.getters.stocks.length)">
            {{label.name}}
                 <em v-if="typeof ( label.print_options.p_quantity) !='undefined'" class="current-label">
                            <i v-for="option in label.print_options.p_quantity.options" v-if="option.isActive">{{option.name}}</i>
                </em>
        </a>
        <div class="mainContainer">
            <div v-if=" !parseInt(this.label.hide_print_options)" class="printOptionsContainer bigContainer product-option">
                <h3 class="title">{{this.label.first_string+' '+this.label.second_string.replace('{current_quantity}',this.label.quantity_placeholder) }} </h3>
                <app-printoptions :type="'all'" :label="label"></app-printoptions>
            </div>
            <div class="linesContainer bigContainer product-option">
                <h3  v-if="(parseInt(this.label.allow_fonts) &&  (label.fonts.length> 1)  && !(parseInt(this.label.hide_print_options)))" class="title">{{this.$store.getters.strings.container2}}</h3>
                <h3  v-if="(parseInt(this.label.allow_fonts) &&  (label.fonts.length> 1)  && parseInt(this.label.hide_print_options))" class="title">{{this.$store.getters.strings.container2+' '+this.label.second_string.replace('{current_quantity}',this.label.quantity_placeholder) }}</h3>
                <div class="subcontainer" v-show="(label.lines.length> 0 )">
                    <h4 class="h5">{{this.$store.getters.strings.lineTitle}}</h4>
                    <app-lines :label="label"></app-lines>
                </div>
                <div
                        v-show="(parseInt(this.label.allow_fonts) &&  label.fonts.length> 1 )">
                    <h4 class="h5">{{this.$store.getters.strings.fontTitle}}</h4>
                    <div class="option-list">
                        <app-font :fonts="label.fonts" :label="label"></app-font>
                </div>
            </div>
                 <h4 class="h5" v-if="(typeof(label.cliparts)!='undefined'&&parseInt(label.cliparts.length))">{{this.$store.getters.strings.svgText}}</h4>
                <div class="allCliparts" v-if="(typeof(label.cliparts)!='undefined'&&parseInt(label.cliparts.length))">
                    <app-cliparts v-for="clipartItems in  label.cliparts" :clipartItems="clipartItems" :label="label"></app-cliparts>
                </div>
                <div class="clipartsCategories" v-if="(typeof(label.cliparts)!='undefined'&&parseInt(label.cliparts.length))">
                    <ul class="clipartsGallery">
                        <li v-for="clipartCategory in label.cliparts" @click="changeCurrentGallery(clipartCategory)" :class="['categoryItem','cmpt',{ active: clipartCategory.active }]">
                            <div v-bind:style="{'background-image': 'url('+clipartCategory.preview_url+')' }"></div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="book_binding" v-if="typeof (label.print_options.book_binding)!='undefined' && label.print_options.book_binding.options.length >1">
                <app-printoptions :type="'book_binding'" :label="label"></app-printoptions>
            </div>
            <div class="product-option" v-show="(typeof ( label.print_options.p_quantity) !='undefined') &&((label.print_options.p_quantity.length > 1) ||(this.$store.getters.labels.length ==1)) && !(edit_type == 'order')" v-if="((typeof ( label.print_options.p_quantity) !='undefined') &&(this.$store.getters.labels.length ==1))  ">
                <h3 class="title">{{this.$store.getters.strings.container3}}</h3>
                <div class="package-block">
                    <div v-for="option in label.print_options.p_quantity.options" :class="[{active: option.isActive},'block','cmpt','p_q'+label.part+option.code, 'page_option'+option.code+'_'+option.product_part]">
                        <h2>{{option.name}}</h2>
                        <span class="price_q"></span>
                        <span class="popular">{{strings.popularchoice}}</span>
                        <strong class="labels" v-if="!(option.option_placeholder)">{{option.qty+ " " + strings.labelsString}}</strong>
                        <strong class="labels" v-if="(option.option_placeholder)">{{option.option_placeholder}}</strong>
                        <p v-show="!(typeof(option.option_description)!='undefined'&&(option.option_description.length))"><span class="price_q_unit"></span>{{strings.perUnitString}}</p>
                        <p v-if="typeof(option.option_description)!='undefined'&&(option.option_description.length)"><span class="option-description">{{option.option_description}}</span></p>
                        <a class="addToCart button" @click="addToCart(option,$event)">{{strings.addPartString}}</a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import Lines from './Lines';
    import Font from './Fonts/Font';
    import Cliparts from "./Cliparts/Cliparts";
    import Printoptions from "./Printoptions/Printoptions";

    export default {
        props      : ['label'],
        data(){
            return {
                strings:this.$store.getters.strings,
                edit_type:window.edit_type
            }
        },
        components : {
            appLines        : Lines,
            appFont         : Font,
            appCliparts     : Cliparts,
            appPrintoptions : Printoptions
        },
        methods    : {
            setActive () {
                this.label.isActive = ! this.label.isActive;
            },
            changeCurrentGallery ( clipartCategory ) {
                this.label.cliparts.forEach( function( element ) {
                    element.active = 0;
                } );
                clipartCategory.active = 1;
            },

            addToCart ( opt ,event) {
                var code = opt.code;
                this.label.current_qty = opt.qty;
                this.label.current_qty_code = opt.code;
                this.label.current_placeholder = opt.option_placeholder;
                event.preventDefault();
                var option = $jQuery('#select_PP_'+opt.product_part+'_'+opt.parent).find( "[name='" + code + "']" );
                if ( option.length ) {
                    option.attr( 'selected', true );
                }
                if ( this.$store.getters.strings.crosselings.length ) {
                     this.$store.dispatch('generatePreview',{});
                }
                else {
                    this.$store.dispatch('generatePreview',{});
                }
            }

        }
    }
</script>
<style>
    .clipartsGallery .active {
        border : solid 3px #005380;;
    }

    .allCliparts {
        width    : 100%;
        height   : auto;
        display  : inline-block;
        float    : left;
        overflow : auto;
        height:186px;
    }

    .labelTitle {
        font-family      : 'SoupBone';
        letter-spacing   : 0.3px;
        color            : #EA8D00;
        float            : left;
        font-size        : 26px;
        display          : inline-block;
        width            : 100%;
        height           : 70px;
        padding          : 19px 30px 22px 30px;
        background-color : #F9F9F9;
        display: none;
    }



    /*   .labelEdit {
        border-radius    : 10px;
        background-color : #FFFFFF;
        border           : solid 2px #EDEDED;
        width            : 100%;
        height           : 100%;
    }*/

    .mainContainer {
        width   : 100%;
        display : inline-block;
        padding : 20px;
    }

    .arrowContainer {
        width            : 22px;
        height           : 22px;
        background-color : #EA8D00;
        border-radius    : 50%;
        float            : right;
        text-align       : center;
        cursor           : pointer;
    }

    .active i.arrow {
        border            : solid #FFFFFF;
        border-width      : 0 3px 3px 0;
        display           : inline-block;
        padding           : 3px;
        transform         : rotate(-135deg);
        -webkit-transform : rotate(-135deg);
        margin-bottom     : 10px;
    }

    i.arrow {
        transform         : rotate(45deg);
        -webkit-transform : rotate(45deg);
    }

    .mainContainer {
        display : none;
    }

    .active .mainContainer {
        display : inline-block;
    }

    .categoryItem {
        width            : 36px;
        height           : 36px;
        background-color : #EDEDED;
        border-radius    : 50%;
        list-style       : none;
        float            : left;
        margin           : 10px;
        cursor           : pointer;
    }
    .clipartsCategories{
        float:left;
        width:100%;
        text-align: center;
    }
    .clipartsCategories ul{
        width:auto;
        display : inline-block;

    }
    .categoryItem.active div {
        opacity:1;
    }
    .categoryItem div {
        width               : 80%;
        height              : 80%;
        background-repeat   : no-repeat;
        background-position : center center;
        background-size     : contain;
        position            : relative;
        top                 : 50%;
        left                : 50%;
        transform           : translate(-50%, -50%);
        opacity: 0.5;
    }

    ul {
        margin  : 0px;
        padding : 0px;
    }


.price_q{
    display: block;
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 0.4px;
    color: #009de0;
    text-decoration: none;
    margin: 0 0 32px;
    letter-spacing: 1.5px
}
    .column.main .block:last-child{
        margin-bottom: 55px;
    }
    .package-block .block.big .price_q {
       margin:0px;
    }
    .package-block .block .popular {
        display:none
    }

    .package-block .block.big .popular {
    font-family: SourceSansPro;
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    /* line-height: 1.5; */
    letter-spacing: normal;
    text-align: center;
    color: #B61070;
    border: 1px solid #B61070;
    border-radius: 5px;
    padding: 0 10px;
    display: inline-block;
    margin: 0 0 32px;

    }

    .editOrderButton{
        height: 20px;
    width: auto;
    float: right;
    padding: 10px;
    background-color: #ea8d00;
    color: #ffff;
    border-radius: 5px;
    cursor: pointer;
}

    .linesContainer .subcontainer{
        margin-bottom:27px;
    }
</style>



// WEBPACK FOOTER //
// src/components/EditLabel.vue